export default "<p>BUCHUNG {{buchung.umsatz}}</p>\n"